import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GSA } from './gsa-settings.model';

@Injectable({
  providedIn: 'root',
})
export class GsaService {
  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  postGsa(gsa: GSA): Observable<any> {
    return this.http.post(this.url + 'gsas', gsa);
  }

  putGsa(gsa: GSA): Observable<any> {
    return this.http.put(this.url + 'gsas', gsa);
  }

  deleteGsa(index: number): Observable<any> {
    return this.http.delete(this.url + 'gsas/' + index);
  }

  fetchGsas(): Observable<any> {
    return this.http.get(this.url + 'gsas');
  }

  getGsaById(index: number): Observable<any> {
    return this.http.get(this.url + 'gsas/' + index);
  }
}
